import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
	@Input() title: string = '';
	@Input() customClass: string[] = [];
	@Input() customContentClass: string = '';
	@Input() showCloseButton: boolean = true;
	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId: Object
	) {}

	ngOnInit(): void {
		if (isPlatformBrowser(this.platformId)) {
			this.document.body.classList.add('modal-open');
			ModalService.closeModal.subscribe(() => {
				this.document.body.classList.remove('modal-open');
			});
		}
	}

	closeByBackdrop(event: any) {
		if (isPlatformBrowser(this.platformId) && event.target.className == 'rod-modal-content') {
			this.document.body.classList.remove('modal-open');
			ModalService.closeModal.emit();
		}
	}

	closeModal() {
		if (isPlatformBrowser(this.platformId)) {
			this.document.body.classList.remove('modal-open');
			ModalService.closeModal.emit();
		}
	}
}
